import React, { useEffect, useRef, useState } from "react";
import NoDataFound from "../../../../Extra/NoDataFound";
import DownloadExcelFromData from "../../../../Extra/DownloadExcelFromData";
import DownloadExcel from "../../../../Extra/DownloadExcel";
const ReasonWiseTable = ({ from, data }) => {
  const [tableData, setTableData] = useState(null);
  const tableRef = useRef();

  const tableHead = {
    "Granted Not": ["Reasons", "No_Of_Demand_By_Engg", "Engg_Demand"],
    // Granted: [],
    "Availed Not": [
      "Reasons",
      "No_Of_Demand_By_Engg",
      "Engg_Demand",
      "No_Of_Demand_Agreed_GIVEN",
      "Granted_Duration",
    ],
    // Availed: [],
  };
  useEffect(() => {
    if (data && data.length > 0) {
      const timeToSeconds = (time) => {
        if (!time || time === "00:00:00") return 0;
        const [h, m, s] = time.split(":").map(Number);
        return h * 3600 + m * 60 + s;
      };

      const secondsToHHMMSS = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
      };

      // Helper function to group and sum
      const groupByReason = (filterKey, filterValue) => {
        return Object.values(
          data
            .filter((item) => item[filterKey] === filterValue)
            .reduce((acc, curr) => {
              const reason = curr.Reason || "Unknown";

              if (!acc[reason]) {
                acc[reason] = {
                  Reasons: reason,
                  No_Of_Demand_By_Engg: 0,
                  No_Of_Demand_Agreed_GIVEN: 0,
                  Engg_Demand: 0,
                  Granted_Duration: 0,
                };
              }

              acc[reason].No_Of_Demand_By_Engg +=
                Number(curr.No_Of_Demand_By_Engg) || 0;
              acc[reason].No_Of_Demand_Agreed_GIVEN +=
                Number(curr.No_Of_Demand_Agreed_GIVEN) || 0;
              acc[reason].Engg_Demand += timeToSeconds(curr.Engg_Demand);
              acc[reason].Granted_Duration += timeToSeconds(
                curr.Granted_Duration
              );

              return acc;
            }, {})
        ).map((obj) => ({
          ...obj,
          Engg_Demand: secondsToHHMMSS(obj.Engg_Demand),
          Granted_Duration: secondsToHHMMSS(obj.Granted_Duration),
        }));
      };

      const tableData = groupByReason(
        from === "Availed Not" ? "Availed_Not" : "Granted_Not",
        from === "Availed Not" ? "NOT AVAILED" : "NOT GRANTED"
      );

      setTableData(tableData);
    }
  }, [data]);
  return (
    <div className="">
      <div className="row bg-dark text-white mb-1">
        <h5>{from}</h5>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-hover " ref={tableRef}>
          <thead className="table-dark">
            <tr>
              <th>Sno</th>
              {tableHead[from].map((head, i) => {
                return <th key={i}>{head.replace(/_/g, " ")}</th>;
              })}
            </tr>
          </thead>
          {data && data.length > 0 && (
            <tbody style={{ fontSize: "12px" }}>
              {tableData &&
                tableData.map((obj, j) => {
                  return (
                    <tr key={j}>
                      <td>{j + 1}-</td>
                      {tableHead[from].map((head, i) => {
                        return <td key={`${i}+${j}`}>{obj[head]}</td>;
                      })}
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>
        {data && data.length === 0 && <NoDataFound />}
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`${from} summery`} />
    </div>
  );
};
export default ReasonWiseTable;
